import { render, staticRenderFns } from "./EditGoods/template.html?vue&type=template&id=53c86c6a&scoped=true&"
import script from "./EditGoods/script.ts?vue&type=script&lang=js&"
export * from "./EditGoods/script.ts?vue&type=script&lang=js&"
import style0 from "./EditGoods/style.scss?vue&type=style&index=0&id=53c86c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c86c6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
